<form [formGroup]="formGroup" (submit)="isFormValid()" fxLayout="column" fxLayoutAlign="center center">

  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="confirmChanges()" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ detail?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_ITEM' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_ITEM' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="disableSaveBtn()">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>

  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- code -->
    <div fxLayout>
      <mat-form-field>
        <input
          #code
          matInput
          required
          autocomplete="off" 
          formControlName="code" 
          [placeholder]="'LABEL_CODE' | translate"
          >

        <mat-error *ngIf="formGroup.get('code').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('code').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '20'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('code').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- description -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #description 
          autocomplete="off" 
          formControlName="description" 
          [placeholder]="'LABEL_DESCRIPTION' | translate"
          >

        <mat-error *ngIf="formGroup.get('description').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('description').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '100'} }}
        </mat-error>
      </mat-form-field>
    </div>
    
    <!-- category -->
    <esc-category-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="categorySelected($event)"
      [previousData]="detail"
      [removeAll]="true"
      [requiredError]="categoryRequired"
      [isRequired]="true"
      [disabled]="isDisabled"
      >
    </esc-category-dropdown>

    <!-- brand -->
    <esc-brand-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="brandSelected($event)"
      [previousData]="detail"
      [removeAll]="true"
      [requiredError]="brandRequired"
      [isRequired]="true"
      [disabled]="isDisabled"
      >
    </esc-brand-dropdown>

    <!-- price_amount -->
    <div fxLayout>
      <mat-form-field>
        <input
          #price_amount
          matInput
          required
          autocomplete="off" 
          formControlName="price_amount" 
          [placeholder]="'LABEL_PRICE_AMOUNT' | translate"
          >

        <mat-error *ngIf="formGroup.controls['price_amount'].hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.controls['price_amount'].hasError('minZero')">
          {{ 'MSG_ERROR_MIN_ZERO' | translate: {quantity: 0} }}
        </mat-error>

        <mat-error *ngIf="formGroup.controls['price_amount'].hasError('decimalErr')">
          {{ 'MSG_ERROR_DECIMAL_PLACES' | translate: {places: '2'} }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>

  </div>
</form>